import { Action } from '@ngrx/store';
import { Location } from '../../models/location.model';

export enum LocationsActionTypes {
  LoadLocations = '[Locations] Load Locations',
  LoadLocationsSuccess = '[Locations] Load Locations Success',
  LoadLocationsFailure = '[Locations] Load Locations Failure',

  LoadLocation = '[Locations] Load Location',
  LoadLocationSuccess = '[Locations] Load Location Success',
  LoadLocationFailure = '[Locations] Load Location Failure',

  CreateLocation = '[Locations] Create Location',
  CreateLocationSuccess = '[Locations] Create Location Success',
  CreateLocationFailure = '[Locations] Create Location Failure',

  UpdateLocation = '[Locations] Update Location',
  UpdateLocationSuccess = '[Locations] Update Location Success',
  UpdateLocationFailure = '[Locations] Update Location Failure',

  DeleteLocation = '[Locations] Delete Location',
  DeleteLocationSuccess = '[Locations] Delete Location Success',
  DeleteLocationFailure = '[Locations] Delete Location Failure',

  SelectLocation = '[Locations] Select Location',
}

export class LoadLocations implements Action {
  readonly type = LocationsActionTypes.LoadLocations;
  constructor(public payload: { filter: any }) { }
}

export class LoadLocationsSuccess implements Action {
  readonly type = LocationsActionTypes.LoadLocationsSuccess;
  constructor(public payload: { items: Location[]; total: number }) { }
}

export class LoadLocationsFailure implements Action {
  readonly type = LocationsActionTypes.LoadLocationsFailure;
  constructor(public payload: { error: any }) { }
}

export class LoadLocation implements Action {
  readonly type = LocationsActionTypes.LoadLocation;
  constructor(public payload: { id: string }) { }
}

export class LoadLocationSuccess implements Action {
  readonly type = LocationsActionTypes.LoadLocationSuccess;
  constructor(public payload: { location: Location }) { }
}

export class LoadLocationFailure implements Action {
  readonly type = LocationsActionTypes.LoadLocationFailure;
  constructor(public payload: { error: any }) { }
}

export class CreateLocation implements Action {
  readonly type = LocationsActionTypes.CreateLocation;
  constructor(public payload: { location: Location }) { }
}

export class CreateLocationSuccess implements Action {
  readonly type = LocationsActionTypes.CreateLocationSuccess;
  constructor(public payload: { location: Location }) { }
}

export class CreateLocationFailure implements Action {
  readonly type = LocationsActionTypes.CreateLocationFailure;
  constructor(public payload: { error: any }) { }
}

export class UpdateLocation implements Action {
  readonly type = LocationsActionTypes.UpdateLocation;
  constructor(public payload: { location: Location }) { }
}

export class UpdateLocationSuccess implements Action {
  readonly type = LocationsActionTypes.UpdateLocationSuccess;
  constructor(public payload: { location: Location }) { }
}

export class UpdateLocationFailure implements Action {
  readonly type = LocationsActionTypes.UpdateLocationFailure;
  constructor(public payload: { error: any }) { }
}

export class DeleteLocation implements Action {
  readonly type = LocationsActionTypes.DeleteLocation;
  constructor(public payload: { id: string; filter: any }) { }
}

export class DeleteLocationSuccess implements Action {
  readonly type = LocationsActionTypes.DeleteLocationSuccess;
  constructor(public payload: { id: string; cancelledBookingsCount: number; filter: any }) { }
}

export class DeleteLocationFailure implements Action {
  readonly type = LocationsActionTypes.DeleteLocationFailure;
  constructor(public payload: { error: any }) { }
}

export class SelectLocation implements Action {
  readonly type = LocationsActionTypes.SelectLocation;
  constructor(public payload: { id: string | null }) { }
}

export type LocationsActions =
  | LoadLocations
  | LoadLocationsSuccess
  | LoadLocationsFailure
  | LoadLocation
  | LoadLocationSuccess
  | LoadLocationFailure
  | CreateLocation
  | CreateLocationSuccess
  | CreateLocationFailure
  | UpdateLocation
  | UpdateLocationSuccess
  | UpdateLocationFailure
  | DeleteLocation
  | DeleteLocationSuccess
  | DeleteLocationFailure
  | SelectLocation;
